module.exports = __webpack_public_path__ + "static/media/bear_bedroom_shades.f34f68b6.png";